export default __webpack_public_path__ + "static/media/customer-service.cef0cc20.svg";